export default __webpack_public_path__ + "static/media/linkedInIcon.ebf9af0f.svg";